export var OG_CONTACT_US_LINK = 'https://opengear.com/contact-us/';
export var OG_DEMO_CONTACT_LINK = 'https://opengear.com/lighthouse-demo';
